export default __webpack_public_path__ + "7b3d2d573abafff925baa0c4062f048c.svg";